import { render, staticRenderFns } from "./pageForm.vue?vue&type=template&id=2dac101e&scoped=true&"
import script from "./pageForm.vue?vue&type=script&lang=js&"
export * from "./pageForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dac101e",
  null
  
)

export default component.exports